import uuid4 from "uuid4";
export function generateReferralCode() {
    return uuid4().slice(0, 8).toUpperCase(); 
}